module.exports = __webpack_public_path__ + "img/banner.5b8b3bfa.png";